export const extractPartNumberFather = (partNumber: string) =>
	partNumber.includes('-T') ? partNumber.split('-T')[0] : partNumber;
